import { render, staticRenderFns } from "./PercenStatCard.vue?vue&type=template&id=858f6f42&"
import script from "./PercenStatCard.vue?vue&type=script&lang=js&"
export * from "./PercenStatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports